<div class="content-layout right-sidebar-fullheight-basic-inner-scroll flex flex-row">
  <div
    class="list-wrapper"
    [ngClass]="{
      'mail-selected': selectedLoanRequest && selectedLoanRequest.id,
      'no-mails': !loanRequests || loanRequests.length === 0,
    }"
  >
    <!-- Mail list header -->
    <div class="header">
      <!-- Header left -->
      <div class="left">
        <!-- Category name -->
        <div class="category">
          <ng-container *ngIf="account && account.subdomain == 'hearn'">LP Tracker</ng-container>
          <ng-container *ngIf="!account || account?.subdomain != 'hearn'">Loan Requests</ng-container>
        </div>
      </div>

      <div class="pagination">
        <!-- Previous page button -->
        <button
          mat-icon-button
          (click)="addLoanRequest()"
          [matTooltip]="'Add'"
          [appAuthorize]="NewPermission.LOAN_QUOTES_CREATE"
          denyAction="disable"
        >
          <mat-icon [svgIcon]="'add_circle_outline'"></mat-icon>
        </button>
      </div>

      <!-- Loading bar -->
      <mat-progress-bar class="loading-progress-bar" *ngIf="isLoading" [mode]="'indeterminate'"></mat-progress-bar>
    </div>

    <!-- Mail list -->
    <div class="list" #noteList>
      <!-- Mail list item loop -->
      <ng-container *ngFor="let loanRequest of loanRequests; let i = index; trackBy: trackByFn">
        <!-- Mail list item -->
        <a
          class="item"
          [ngClass]="{ selected: selectedLoanRequest && selectedLoanRequest.id === loanRequest.id }"
          [routerLink]="[loanRequest.id]"
          (click)="onLoanRequestSelected(loanRequest)"
        >
          <div class="item-content">
            <!-- Info -->
            <div class="info">
              <!-- Sender name -->
              <div class="name">
                {{ loanRequest.loan_purpose?.name }}
              </div>

              <!-- Date -->
              <div class="date">
                <div>{{ loanRequest.created_at | date: 'LLL dd, y' }}</div>
                <div>
                  {{ loanRequest.loan_quotes?.length }}
                  {{
                    loanRequest.loan_quotes?.length
                      | i18nPlural
                        : {
                            '=0': '',
                            '=1': 'quote',
                            other: 'quotes',
                          }
                  }}
                </div>
              </div>
            </div>

            <!-- Subject -->
            <div class="excerpt">
              {{ loanRequest.description | slice: 0 : 80 }}
              <ng-container *ngIf="loanRequest.description?.length > 80">...</ng-container>
            </div>
          </div>
        </a>
      </ng-container>
    </div>

    <!-- No mails template -->
    <ng-template #noMails>
      <div class="no-mails">
        <mat-icon [svgIcon]="'iconsmind:mailbox_empty'"></mat-icon>
        <h4>There are no loan requests</h4>
      </div>
    </ng-template>
  </div>

  <!-- Mail details -->
  <router-outlet *ngIf="loanRequests && loanRequests.length > 0"></router-outlet>
</div>
